export default __webpack_public_path__ + "static/media/logoLocationNotAllowed.4615acfc.png";